import { createSlice } from "@reduxjs/toolkit";

const fantacySlice = createSlice({
    name: 'FantacySliceData',
    initialState: {
        FnCurrentUpcommingList: [],
        FnTeamsAllList: [],
        FnPlayersByMatchList: [],
        FnContestList: [],
        FnUserContestList: [],
        FnClientCompletedList: [],
        FnCompletedContestList: [],
    },
    reducers: {
        saveFnCurrentUpcommingList: (state, action) => {
            state.FnCurrentUpcommingList = action.payload
        },
        saveFnTeamsAll: (state, action) => {
            state.FnTeamsAllList = action.payload
        },
        saveFnPlayersByMatch: (state, action) => {
            state.FnPlayersByMatchList = action.payload
        },
        saveFnContestList: (state, action) => {
            state.FnContestList = action.payload
        },
        saveFnUserContestList: (state, action) => {
            state.FnUserContestList = action.payload
        },
        saveFnClientCompletedList: (state, action) => {
            state.FnClientCompletedList = action.payload
        },
        saveFnCompletedContestList: (state, action) => {
            state.FnCompletedContestList = action.payload
        },
    }
})

export const { saveFnCurrentUpcommingList, saveFnTeamsAll, saveFnPlayersByMatch, saveFnContestList, saveFnUserContestList, saveFnClientCompletedList, saveFnCompletedContestList } = fantacySlice.actions;
export default fantacySlice.reducer